/**
 * Personuppgiftsavtal — the standalone, signed sibling of the
 * personuppgiftsbilaga. Sections 2–9 are the bilaga's own blocks; only § 1
 * (landlord identity autofilled from the lessor party) and the closing
 * § 10 (confirmation + Underskrifter) are specific to this document.
 */
import { p, section } from '@hyranai/regta-document-ir';
import { signingNodes } from '../common/index.js';
import { BEKRAFTELSE_TEXT, SOURCE, personuppgiftsansvarigBlock } from '../personuppgiftsbilaga/blocks.js';
import { legalBase } from '../personuppgiftsbilaga/text.js';
export const personuppgiftsansvarig = personuppgiftsansvarigBlock('personuppgiftsavtal.personuppgiftsansvarig', 'standalone');
/**
 * § 10: the confirmation, then the shared legacy SigningBlock inside the
 * section. Signing parties and `statement` are instance input; place/date
 * and the digital wording follow the host's `ctx.custom.signing`.
 */
export const bekraftelse = {
    ...legalBase(SOURCE),
    blockKey: 'personuppgiftsavtal.bekraftelse',
    version: 'v1',
    title: 'Bekräftelse',
    summary: 'The tenant’s confirmation of receipt followed by the signature panels of both parties.',
    slots: [],
    compile: (input, ctx) => [
        section('bekraftelse', 'Bekräftelse', [p(BEKRAFTELSE_TEXT), ...signingNodes(input, ctx)], { keepTogether: true }),
    ],
};
export const PERSONUPPGIFTSAVTAL_BLOCKS = [personuppgiftsansvarig, bekraftelse];
//# sourceMappingURL=blocks.js.map